import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

const HeroHeading = props => (
  <div className={css(styles.container)}>{props.children}</div>
);

export default HeroHeading;

HeroHeading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
};

styles = StyleSheet.create({
  container: {
    fontFamily: Theme.font_family_heading,
    fontSize: 100,
    textAlign: 'center',
    color: Theme.white,
    width: Theme.container_width / 2,
    fontWeight: Theme.font_weight_heading,
    marginBottom: 10,

    [Theme.mobile_query]: {
      width: '100%',
      padding: '0 25px',
      fontSize: 45,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/HeroHeading/index.js